/**
 * Erros de `GET /customer-portal/summary`. 401 nunca chega aqui: o ApiClient
 * trata a sessão expirada antes.
 */

interface ApiErrorLike {
  response?: {
    status?: number;
  };
}

export function customerPortalSummaryErrorMessage(error: unknown): string {
  const status = (error as ApiErrorLike)?.response?.status;
  if (status === 403) return "Você não tem acesso aos valores desta unidade.";
  if (status === 404) return "Unidade não encontrada.";
  if (status === 502)
    return "O ERP financeiro está indisponível no momento. Tente novamente mais tarde.";
  return "Não foi possível carregar os valores. Tente novamente mais tarde.";
}
